module.exports = __webpack_public_path__ + "img/down-fj2.6240dfa6.jpg";